// @mui
import PropTypes from "prop-types";
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
// components
import Iconify from "../../../components/Iconify";
import { useState } from "react";
import "./style.css";
// ----------------------------------------------------------------------

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: "center",
  marginBottom: theme.spacing(3),
}));

const dnone = {
  display: "none",
};

const dshow = {
  display: "show",
};

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

export default function AppWidgetSummary({
  title,
  total,
  icon,
  color = "primary",
  sx,
  ...other
}) {
  // const [display,setDispaly] = useState("false");

  // const handleDisplay = () =>{
  //   setDispaly(!Display);

  // };

  return (
    <Card
      className="Display_details"
      sx={{
        padding: 2.5,
        boxShadow: 0,
        textAlign: "center",
        color: "",
        bgcolor: "#e6e6ff",
        ...sx,
        minHeight: "229px",
      }}
      {...other}
    >
      <IconWrapperStyle
        sx={{
          color: "",
          width: "70px",
          bgcolor: "white",
        }}
        className="icon"
      >
        <Iconify icon={icon} width={70} height={70} />
      </IconWrapperStyle>

      <Typography className="display_elements" variant="h3">
        {fShortenNumber(total ? total : 0)}
      </Typography>

      <Typography className="display_elements1" variant="subtitle2">
        {title}
      </Typography>
    </Card>
  );
}
